























import {Vue, Component, Prop} from 'vue-property-decorator'
import {$} from '@/facade'

import NavbarWalletSessionConnectedButton from '@/components/navbar/NavbarWalletSessionConnectedButton.vue'
import NavbarWalletSessionConnectedDropdown from '@/components/navbar/NavbarWalletSessionConnectedDropdown.vue'

@Component({
  components: {
    NavbarWalletSessionConnectedButton,
    NavbarWalletSessionConnectedDropdown,
  },
})
export default class NavbarWalletSessionConnected extends Vue {
  @Prop({required: true}) n3Address!: string | null
  @Prop({required: true}) xAddress!: string | null

  dropdownSessionIsOpen = false

  toggleModalSession() {
    this.dropdownSessionIsOpen = !this.dropdownSessionIsOpen
  }
}
